import React from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from '@/lib/sentry'
import RendererApp from '@/renderer/RendererApp'

initSentry()

const container = document.getElementById('renderer-root')
if (container) {
  const content = container.dataset.content
  const demoId = container.dataset.demoId ? Number(container.dataset.demoId) : undefined
  if (content) {
    const root = createRoot(container)
    root.render(<RendererApp content={JSON.parse(content)} demoId={demoId} />)
  }
}
